var _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArticleinline = function SvgArticleinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.923 102.923H32.077A7.077 7.077 0 0 1 25 95.846v-70.77A7.077 7.077 0 0 1 32.077 18H69.78c1.875 0 3.675.745 5.002 2.07l17.142 17.126A7.081 7.081 0 0 1 94 42.203v53.643a7.077 7.077 0 0 1-7.077 7.077Z",
    fill: "#75D5F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91.925 37.198 74.783 20.072a7.034 7.034 0 0 0-2.014-1.384v13.466a7.077 7.077 0 0 0 7.077 7.077h13.475a7.049 7.049 0 0 0-1.396-2.033Z",
    fill: "#0E8AB1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 48,
    width: 31,
    height: 5,
    rx: 2,
    fill: "#0E8AB1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 25,
    width: 13,
    height: 5,
    rx: 2,
    transform: "rotate(90 36 25)",
    fill: "#F4FDFF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 48,
    width: 5,
    height: 5,
    rx: 2,
    fill: "#0E8AB1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 60,
    width: 31,
    height: 5,
    rx: 2,
    fill: "#0E8AB1"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 60,
    width: 5,
    height: 5,
    rx: 2,
    fill: "#0E8AB1"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 72,
    width: 31,
    height: 5,
    rx: 2,
    fill: "#0E8AB1"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 72,
    width: 5,
    height: 5,
    rx: 2,
    fill: "#0E8AB1"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 84,
    width: 31,
    height: 5,
    rx: 2,
    fill: "#0E8AB1"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 84,
    width: 5,
    height: 5,
    rx: 2,
    fill: "#0E8AB1"
  })));
};
export default SvgArticleinline;